import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Fail closed: no hardcoded URL/key fallback. Configure via env (.env for local
// dev, build env vars in Netlify) so credentials never live in source.
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase config — set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your environment.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Safari can deadlock on the Web Locks API that auth-js uses to serialize
    // sessions across tabs — getSession() then hangs with no error (infinite
    // loading spinner in production). Use a pass-through lock to avoid it; this
    // is a single-user research tool, so cross-tab refresh serialization is not
    // worth the hang risk.
    lock: async (_name, _acquireTimeout, fn) => fn(),
  },
});

// NOTE: never instantiate a service-role client in browser code — a VITE_-prefixed
// key would be inlined into the client bundle (full DB admin leak). Privileged
// operations must run server-side (Supabase Edge Functions) only.

export const TABLES = {
  ORGANIZATIONS: 'organizations_1740026207000',
  USER_PROFILES: 'user_profiles_1740026207000',
  ORG_MEMBERS: 'org_members_1740026207000',
  PROJECT_MEMBERS: 'project_members_1740026207000',
  PROJECTS: 'projects_1740026207000',
  SCREENER_QUESTIONS: 'screener_questions_1740026207000',
  SCREENER_QUESTION_TARGETS: 'screener_question_targets_1740026207000',
  SCREENER_RESPONSES: 'screener_responses_1740026207000',
  SEGMENT_TAGS: 'segment_tags_1740026207000',
  MODULES: 'modules_1740026207000',
  MODULE_ITEMS: 'module_items_1740026207000',
  TOUCHPOINT_CARDS: 'touchpoint_cards_1740026207000',
  JOURNEY_MAP_LANES: 'journey_map_lanes_1740026207000',
  SESSIONS: 'sessions_1740026207000',
  ACTIVE_SESSION_STATE: 'active_session_state_1740026207000',
  SESSION_MODULES: 'session_modules_1740026207000',
  JOURNEY_MAP_PLACEMENTS: 'journey_map_placements_1740026207000',
  XY_PLOT_PLACEMENTS: 'xy_plot_placements_1740026207000',
  MODULE_ITEM_RELATIONSHIPS: 'module_item_relationships_1740026207000',
  MODULE_ITEM_ALLOCATIONS: 'module_item_allocations_1740026207000',
  DIARY_ENTRIES: 'diary_entries_1740026207000',
  JOURNEY_SNAPSHOTS: 'journey_snapshots_1740026207000'
};